
export const ulmsUrl = "https://holiboardapi.holisollogistics.com/api";

export const holibookUrl = "https://holibook.holisollogistics.com/api";

export const username = "HBOOKAPP";

export const password = "U0VKUFQwdEJVRkF0TWpBeU1qQTJNRGs9";
